import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-pin",
  "use": "icon-pin-usage",
  "viewBox": "0 0 20 29",
  "content": "<symbol fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 20 29\" id=\"icon-pin\"><path d=\"M10 27.205a63.426 63.426 0 01-4.381-5.65c-1.236-1.802-2.46-3.82-3.373-5.836C1.328 13.693.75 11.722.75 10 .75 4.898 4.898.75 10 .75s9.25 4.148 9.25 9.25c0 1.722-.578 3.693-1.496 5.72-.913 2.016-2.137 4.033-3.373 5.835a63.434 63.434 0 01-4.38 5.65z\" stroke=\"currentColor\" stroke-width=\"1.5\" /><circle cx=\"10.121\" cy=\"9.663\" r=\"3.972\" stroke=\"currentColor\" stroke-width=\"1.5\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol